import { render } from "./AppHeaderDropdownMssgs.vue?vue&type=template&id=19e50c62"
import script from "./AppHeaderDropdownMssgs.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownMssgs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__